/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function Robinhood16({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="16"
      role="img"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.189 1.554C8.055 2.618 6.899 3.9 6.899 3.9c-.034.042-.006.098.036.077a33.163 33.163 0 0 1 3.478-.56c.245-.021.385.021.392.224.003.073.005.204.008.382.008.643.024 1.893.14 3.16.006.049.055.07.09.028 0 0 1.092-1.547 2.156-2.744a.426.426 0 0 0 .091-.217c.196-1.337-.042-2.478-.455-2.877-.455-.44-1.757-.546-3.346-.007a.73.73 0 0 0-.3.19Z"
        fill={CssVars.textColor}
      />
      <path
        d="M10.418 7.995c-.042-.39-.207-1.933-.2-3.326 0-.028-.043-.035-.05-.021-.114.147-.256.317-.422.516-.919 1.102-2.577 3.092-4.456 6.91-.021.028.014.063.042.05.054-.022.12-.05.2-.081.614-.25 1.935-.784 3.201-1.089a.145.145 0 0 0 .098-.07 49.88 49.88 0 0 1 1.582-2.722l.003-.008a.176.176 0 0 0 .011-.07c0-.01-.004-.04-.01-.09Zm-.803-3.767c.021-.028 0-.063-.028-.056-.882.084-2.296.371-3.415.637-.089.02-.111.047-.144.087l-.003.004-.22.273c-.701.872-1.19 1.48-2.048 2.75a.29.29 0 0 0-.05.19c.099.686.288 1.854.442 2.408a.082.082 0 0 1 .001.041l-.001.014c-.28.805-.651 1.988-1.232 4.354-.007.035.014.07.049.07h.294c.028 0 .049-.007.056-.028.007-.014.007-.02.007-.02 1.799-4.88 4.115-8.204 6.292-10.724ZM4.59 13.782l.321-.77a.136.136 0 0 1 .07-.07c.84-.365 1.422-.567 2.226-.846l.042-.015c.035-.014.063.021.05.056l-.225.448c-.028.063-.063.091-.133.126-1.148.539-1.778.84-2.302 1.12-.028.014-.063-.014-.05-.049Z"
        fill={CssVars.textColor}
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
